import type { ComponentType } from 'react'
import { Text, View } from 'react-native'
import type { LucideProps } from 'lucide-react-native'
import { colors } from '@chillout/core'
import { Button } from '@chillout/ui'

interface SectionPlaceholderProps {
  variant?: 'empty' | 'no-results'
  Icon: ComponentType<LucideProps>
  title: string
  description: string
  buttonLabel?: string
  onActionPress?: () => void
}

export function SectionPlaceholder({
  variant = 'empty',
  Icon,
  title,
  description,
  buttonLabel,
  onActionPress,
}: SectionPlaceholderProps) {
  const isNoResults = variant === 'no-results'

  return (
    <View className="items-center px-4 py-8 sm:py-10">
      <View
        className={`items-center justify-center rounded-full ${
          isNoResults ? 'h-16 w-16 bg-border' : 'h-20 w-20 bg-accent/10'
        }`}
      >
        <Icon
          size={isNoResults ? 28 : 34}
          color={isNoResults ? colors.text.muted : colors.accent.DEFAULT}
          strokeWidth={1.8}
        />
      </View>
      <Text className="mt-4 text-center text-xl font-bold text-primary">{title}</Text>
      <Text className={`text-center text-base font-normal text-secondary ${isNoResults ? 'mt-2' : 'mt-3'}`}>
        {description}
      </Text>
      {buttonLabel && onActionPress ? (
        <Button
          variant="outline"
          label={buttonLabel}
          onPress={onActionPress}
          className="mt-6 w-full sm:w-auto"
        />
      ) : null}
    </View>
  )
}
